/* eslint-disable react/react-in-jsx-scope */
import CallForProjectsCreateProject from "@/pages/submit/CallForProjectsCreateProject";
import { useParams } from "react-router-dom";

const CallForProjectsProjectSheet = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const parsedProjectId = Number(projectId);

  return (
    <CallForProjectsCreateProject
      listPath="/submit/appels-a-projets"
      projectId={Number.isFinite(parsedProjectId) ? parsedProjectId : null}
    />
  );
};

export default CallForProjectsProjectSheet;
